module.exports = __webpack_public_path__ + "img/bg_main_l_2.4b325c8d.png";